import React from 'react';
import { XMarkIcon } from '../UI/Icons';
import BusinessHoursSettings from './BusinessHoursSettings';

interface BusinessHoursPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

const BusinessHoursPanel: React.FC<BusinessHoursPanelProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 ease-in-out"
        onClick={onClose}
        aria-hidden="true"
      ></div>

      <div
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        role="dialog"
        aria-modal="true"
        aria-labelledby="business-hours-title"
      >
        <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] transform transition-all duration-300 ease-in-out scale-100 opacity-100 flex flex-col">
          <div className="flex items-center justify-between p-4 border-b border-gray-200 flex-shrink-0">
            <h2 id="business-hours-title" className="text-lg font-semibold text-gray-800">Business Hours & Timezone</h2>
            <button 
              onClick={onClose} 
              className="text-gray-500 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100"
              aria-label="Close settings"
            >
              <XMarkIcon className="w-6 h-6" />
            </button>
          </div>
          
          <div className="flex-grow overflow-y-auto p-4">
             <BusinessHoursSettings />
          </div>
        </div>
      </div>
    </>
  );
};
export default BusinessHoursPanel;
